import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlMorfologico/filtrarControlMorfologico`, method: 'POST', body: values, token: token})
}
